import { TamaguiElement, YStack, YStackProps } from '@mythical/ui'
import { SolitoImage } from 'solito/image'
import { forwardRef } from 'react'

interface AvatarProps extends YStackProps {
  src?: string
}

export const Avatar = forwardRef<TamaguiElement, AvatarProps>(
  ({ src, ...props }, ref) => {
    return (
      <YStack
        ref={ref}
        w={50}
        h={50}
        br="$pill"
        {...props}
        pos="relative"
        ov="hidden"
      >
        {!!src && <SolitoImage fill src={src} alt="Avatar" sizes="50px" />}
        {!src && (
          <SolitoImage
            fill
            src={require('app/assets/images/profile-image--default.png')}
            alt="Avatar"
          />
        )}
      </YStack>
    )
  },
)
